import { Button, Icon, Segment } from "semantic-ui-react";

import { QUESTION_RESULT_STATUSES } from "models";
import { ElementConfiguration } from "modules/QuestionsDashboard/components/EditQuestionModal/components/QuestionElements/components/QuestionElementCard/components";
import { getElementConfiguration } from "modules/QuestionsDashboard/util";

import type { QuestionElement } from "models";
import type { QuestionElementConfiguration } from "modules/QuestionsDashboard/util";
import type { SemanticCOLORS } from "semantic-ui-react";

type QuestionElementCardProps = {
  questionElement: QuestionElement;
  isFirst: boolean;
  isLast: boolean;
  canEdit: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onRemove: () => void;
  onChangeConfiguration: (configuration: QuestionElementConfiguration) => void;
};

const STATUS_TOGGLES: { status: QUESTION_RESULT_STATUSES; text: string; color: SemanticCOLORS }[] = [
  { status: QUESTION_RESULT_STATUSES.OKWithRemarks, text: "T", color: "green" },
  { status: QUESTION_RESULT_STATUSES.Advice, text: "A", color: "orange" },
  { status: QUESTION_RESULT_STATUSES.Necessary, text: "N", color: "red" }
];

export const QuestionElementCard = ({ questionElement, isFirst, isLast, canEdit, onMoveUp, onMoveDown, onRemove, onChangeConfiguration }: QuestionElementCardProps) => {
  const configuration = getElementConfiguration(questionElement.default_configuration);
  const disabledStatuses = configuration.disabled_statuses ?? [];

  const handleToggleStatus = (status: QUESTION_RESULT_STATUSES) =>
    onChangeConfiguration({
      ...configuration,
      disabled_statuses: disabledStatuses.includes(status) ? disabledStatuses.filter(disabledStatus => disabledStatus !== status) : [...disabledStatuses, status]
    });

  return (
    <Segment className="QuestionElementCard">
      <div className="question-element-header">
        <h3 className="question-element-name">{questionElement.name}</h3>

        <div className="question-element-statuses">
          {STATUS_TOGGLES.map(statusToggle => (
            <Button
              key={statusToggle.status}
              type="button"
              size="small"
              disabled={!canEdit}
              color={disabledStatuses.includes(statusToggle.status) ? undefined : statusToggle.color}
              onClick={() => handleToggleStatus(statusToggle.status)}
            >
              {statusToggle.text}
            </Button>
          ))}
        </div>

        {canEdit && (
          <div className="question-element-actions">
            <Button type="button" className="-appointment-status icon" size="small" onClick={onRemove}>
              <Icon className="trash" color="red" />
            </Button>

            {!isFirst && (
              <Button type="button" className="-appointment-status icon" size="small" onClick={onMoveUp}>
                <Icon className="chevron up" color="black" />
              </Button>
            )}

            {!isLast && (
              <Button type="button" className="-appointment-status icon" size="small" onClick={onMoveDown}>
                <Icon className="chevron down" color="black" />
              </Button>
            )}
          </div>
        )}
      </div>

      <ElementConfiguration template={questionElement.template} configuration={configuration} canEdit={canEdit} onChange={onChangeConfiguration} />
    </Segment>
  );
};
